import { QualityLevel } from "../organisation/Organisation"
import { Transactor, buildTransactorFromDetail } from "../person/Transactor"

export class BidModel {
    id?: number
    price_per_quantity_unit?: number
    organisationId?: number
    market_day?: string
    transactor: Transactor
    createdAt: string
    updated_by: string
    updated_at: string
    qbp: QualityLevel[]

    constructor(b: any) {
        this.id = b.id
        this.price_per_quantity_unit = b.price_per_kg
        this.organisationId = b.organisationId
        this.market_day = b.market_day
        this.transactor = b.transactor ? buildTransactorFromDetail(b.transactor) : undefined
        this.createdAt = b.created_at
        this.updated_at = b.updated_at
        this.updated_by = b.updated_by
        this.qbp = b.grading?.map(q => QualityLevel.build(q))
    }
}

export function buildBidModel(p: any): BidModel {
    return new BidModel(p)
}
